import { GetVillageList } from "@/services/application.service";
import type { ApplicationData } from "@/types/Application/application";
import { message } from "antd";
import { useRef, useState } from "react";

export function useApplicationVillage() {
  const [loading, setLoading] = useState(true);
  const [applicationVillageList, setApplicationVillageList] =
    useState<ApplicationData | null>(null);
  const requestIdRef = useRef(0);

  const fetchApplicationVillageList = async (
    search = "",
    pageNumber = 1,
    pageSize = 25,
    categoryKey = "",
    dateFrom = "",
    mdVillageId: number,
  ) => {
    const requestId = ++requestIdRef.current;

    try {
      setLoading(true);

      const response = await GetVillageList({
        pageNumber,
        pageSize,
        search,
        dateFrom,
        categoryKey,
        mdVillageId,
      });

      if (requestId !== requestIdRef.current) {
        return;
      }

      setApplicationVillageList(response.data);
    } catch (error) {
      if (requestId !== requestIdRef.current) {
        return;
      }

      message.error(
        error instanceof Error
          ? error.message
          : "Gagal mendapatkan senarai permohonan",
      );
    } finally {
      if (requestId === requestIdRef.current) {
        setLoading(false);
      }
    }
  };

  return {
    fetchApplicationVillageList,
    loading,
    applicationVillageList,
  };
}